import { FC } from 'react'
import { useSimpleGuard } from 'helpers/loadableHelpers'
import { memberAuthGuard, feedMemberAuthGuard } from 'guards/globalGuards'
import PageLoadingOverlay from 'components/atoms/preloaders/PageLoadingOverlay'

const EMPTY_OWN_PROPS = {}

export const OptionalAuthGuard: FC = (props) => {
  const { children } = props

  const isMemberLoaded = useSimpleGuard(memberAuthGuard, EMPTY_OWN_PROPS, 'OptionalAuthGuard')
  const isFeedMemberLoaded = useSimpleGuard(feedMemberAuthGuard, EMPTY_OWN_PROPS, 'OptionalAuthGuard')

  if (!isMemberLoaded || !isFeedMemberLoaded) {
    return (
      <PageLoadingOverlay />
    )
  }

  return (
    <>{ children }</>
  )
}
